import {getMethod} from '@/api'

export const get = async params =>
    await getMethod('/proxy/customDocuments', params, null, {responseType: 'arraybuffer'})
